import { Provider } from "react-redux";
import { store } from "./redux/store";
import { Layout, Routes, ToastContainer } from "./components";
import "./scss/index.scss";
import { BrowserRouter } from "react-router-dom";

const App = () => (
  <>
    <ToastContainer />
    <BrowserRouter>
      <Provider store={store}>
        <Layout>
          <Routes />
        </Layout>
      </Provider>
    </BrowserRouter>
  </>
);

export default App;
